import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
import { AppHeaderSettingLinkViewerFragmentDoc } from './AppHeaderSettingLink.generated';
export type DefaultAppHeaderQueryFragment = { __typename?: 'Query', viewer: { __typename?: 'Viewer', profile: { __typename?: 'PlannerProfile', name: string, avatar?: any | null }, staff: { __typename?: 'Staff', email: string } } };

export const DefaultAppHeaderQueryFragmentDoc = gql`
    fragment DefaultAppHeaderQuery on Query {
  viewer {
    ...AppHeaderSettingLinkViewer
  }
}
    ${AppHeaderSettingLinkViewerFragmentDoc}`;